// extracted by mini-css-extract-plugin
module.exports = {"topBox":"style_topBox__3dtPu","container":"style_container__uw-ei","headerBox":"style_headerBox__1RwXI"};